<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div class="navigation">
    <span
      class="visually-hidden"
      v-text="$string('general.site_header.navigation')"
    />

    <nav class="navigation__nav container">
      <ul
        class="navigation__list"
        @blur="closeMegaNavs"
        @mouseleave="closeMegaNavs"
      >
        <navigation-link
          v-for="(tier1) of desktop.items"
          :key="tier1.handle"
          :tier="tier1"
          :mega-nav-footer="megaNavFooter"
        />
      </ul>
    </nav>
  </div>
</template>

<script>

/**
 * Vue: Navigation (navigation)
 * -----------------------------------------------------------------------------
 * Desktop navigation links.
 * - No style import as it's included in critical stylesheet.
 *
 * @param {Object} desktop - Desktop linklist handle and items.
 *
 */
import NavigationLink from '~global/site-header-group/navigation/navigation-link'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Navigation',

  components: {
    NavigationLink,
  },

  props: {
    desktop: {
      type: Object,
      default: () => ({
        handle: 'main-menu',
        items: [],
      }),
    },
    megaNavFooter: {
      type: Object,
      default: () => ({
        text: '',
        url: '',
      }),
    },
  },

  data() {
    return {
      activeTier: false,
    }
  },

  methods: {

    /**
     * Close all mega navs
     */
    closeMegaNavs() {
      cnvs.EventBus.emit('mega-nav:visible', '')
    },
  },
}
</script>
